import {unauthenticated_api} from "./base";

const jsonConfig = {headers: {"Content-Type": "application/json"}};

export const verifyEmailApi = async (token, password) => {
  const payload = password === undefined ? {token} : {token, password};
  try {
    return await unauthenticated_api.post(
      "/user/verify-email/",
      payload,
      jsonConfig
    );
  } catch (error) {
    return error.response;
  }
};

export const resendVerificationEmailApi = async (email) => {
  try {
    return await unauthenticated_api.post(
      "/user/verify-email/resend/",
      {email},
      jsonConfig
    );
  } catch (error) {
    return error.response;
  }
};
